export default __webpack_public_path__ + "static/media/loadingGIF.5c457fd6.gif";